import type { Theme } from "@mui/material";
import type { SxProps, SystemStyleObject } from "@mui/system";
import type { ThemeV2 } from "../../util/types";

export const ratingParentContainer: SxProps = {
  display: "flex",
  width: "100%",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
};

export const ratingContainerCommon = (
  isLandScapeMode: boolean,
  primaryColor: string,
): SxProps => ({
  minHeight: isLandScapeMode ? "100%" : "auto",
  padding: isLandScapeMode ? "24px 27px 8px 18px" : "8px 12px 8px 12px",
  border: isLandScapeMode ? "1px solid" : `1px solid ${primaryColor}`,
  borderRadius: isLandScapeMode ? "12px" : 10,
  margin: isLandScapeMode ? null : "10px",
  boxShadow: 3,
  marginX: "20px",
  backgroundColor: "white",
});

export const textMark = (theme: ThemeV2): SxProps => ({
  maxWidth: { md: "150px", xs: "120px" },
  color: theme.tokens.color.action.primary,
  overflowWrap: "break-word",
  fontSize: {
    sm: theme.tokens.typography.size.md,
    xs: theme.tokens.typography.size.xs,
  },
  textAlign: "center",
});

export const actionBtnWrapper: SxProps = {
  marginBottom: 2,
  marginRight: 2,
  position: "absolute",
  bottom: 0,
  right: 0,
};

export const sliderMarkValues = (theme: ThemeV2): SystemStyleObject<Theme> => ({
  marginTop: 3,
  marginBottom: 0,
  "& .MuiSlider-markLabel": {
    top: "calc(50% - 10px)",
    transform: "translate(-50%, -100%)",
    "@media (pointer: coarse)": {
      top: "calc(50% - 8px)",
    },
    color: theme.tokens.color.action.primary,
  },
});

export const loadingContainer: SxProps = {
  padding: "2rem 0",
  display: "flex",
  justifyContent: "center",
  width: "100%",
  alignItems: "center",
};

export const buttonValueContainer: SxProps = {
  display: "flex",
  justifyContent: "center",
  width: "100%",
};

/* c8 ignore next */
export const buttonValueContent = (
  theme: ThemeV2,
  isSelected: boolean,
): SxProps => ({
  border: 1,
  flex: "1 1 0",
  minWidth: 0,
  padding: `${theme.tokens.spacing["1"]}px 0`,
  width: "100%",
  textAlign: "center",
  borderColor: theme.tokens.color.action.primary,
  backgroundColor: isSelected
    ? theme.tokens.color.action.primary
    : theme.tokens.color.surface.card,
  color: isSelected
    ? theme.tokens.color.action.primaryText
    : theme.tokens.color.action.primary,
  cursor: "pointer",
  fontSize: theme.tokens.typography.size,
});
